export const GUARDIAN_RELATIONSHIP_OPTIONS = [
  "Mother",
  "Father",
  "Legal guardian",
  "Grandparent",
  "Step-parent",
  "Foster carer",
  "Other",
];

export const MINOR_NOTICE =
  "This patient is under 18. A parent or legal guardian must complete the guardian consent section below and confirm consent on the patient's behalf.";
export const GUARDIAN_NOTICE =
  "A parent or legal guardian must complete the guardian consent section below and confirm consent on the patient's behalf.";
export const PATIENT_SIGNATURE_OPTIONAL_NOTE =
  "The patient may also sign if they are able to. This is optional.";
export const DOB_MISSING_WARNING = "DOB missing, minor status cannot be confirmed";

// Mirrors backend services/minor_consent.resolve_guardian_section
export function resolveGuardianSection(template, minorInfo, override) {
  if (override) return override;
  const mode = template?.minor_mode || "auto";
  const guardianRequired = Boolean(minorInfo?.guardian_required);
  const show = mode === "never" ? false : mode === "always" ? true : guardianRequired;
  return {
    mode,
    show,
    required: show,
    relationship_options: GUARDIAN_RELATIONSHIP_OPTIONS,
    notice: show ? (minorInfo?.is_minor ? MINOR_NOTICE : GUARDIAN_NOTICE) : null,
    patient_signature_optional: show,
    patient_signature_note: show ? PATIENT_SIGNATURE_OPTIONAL_NOTE : null,
  };
}

export const emptyGuardian = () => ({ name: "", relationship: "", relationship_other: "" });

export function validateGuardian(guardian, required, signature) {
  if (!required) return null;
  const g = guardian || {};
  if (!(g.name || "").trim()) return "Please enter the parent or guardian's full name.";
  if (!(g.relationship || "").trim()) return "Please select the guardian's relationship to the patient.";
  if (g.relationship === "Other" && !(g.relationship_other || "").trim())
    return "Please describe the guardian's relationship to the patient.";
  if (!signature || !signature.data) return "Please provide the parent or guardian's signature.";
  return null;
}

export function guardianPayload(guardian, signature) {
  const g = guardian || {};
  if (!signature && !(g.name || "").trim()) return null;
  return {
    name: (g.name || "").trim(),
    relationship: (g.relationship || "").trim(),
    relationship_other: (g.relationship_other || "").trim() || null,
    signature_type: signature?.type || null,
    signature_data: signature?.type === "drawn" ? signature.data : null,
    typed_signature: signature?.type === "typed" ? signature.data : null,
  };
}
